import { render } from "./GlobalError.vue?vue&type=template&id=18fb30e6"
import script from "./GlobalError.vue?vue&type=script&lang=js"
export * from "./GlobalError.vue?vue&type=script&lang=js"

import exportComponent from "D:\\FreedomLk\\legal-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__